import { fileUpload } from "directus/src/operations";
import { queryClient } from "utils/react-query";

const collection = "testimonials";

export function invalidateAllTestimonialsQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}

// Uploads the video when a new File was picked and returns the payload with the file id.
export async function withUploadedVideo(item) {
  if (!(item?.video instanceof File)) return item;
  const formData = new FormData();
  formData.append("file", item.video);
  const uploaded = await fileUpload(formData);
  return { ...item, video: uploaded.id };
}

export function buildPayload(values) {
  if (!values || typeof values !== "object") return {};
  return Object.fromEntries(
    Object.entries(values).filter(
      ([_, v]) => v !== "" && v !== undefined && v !== null
    )
  );
}
